module.exports = __webpack_public_path__ + "img/icon-rank-2.10b954d1.svg";